import styled from 'styled-components';

export const Wrapper = styled.div`
  overflow: auto;
  table {
    width: 100%;
    border-collapse: collapse;
  }
  td,
  th {
    border: 1px solid #999;
    padding: 0.5rem;
  }
  .row-heading {
    background-color: orange;
    text-align: center;
    font-weight: bold;
  }
  th {
    font-weight: bold;
  }
`;
